<template>
    <div class="newsRight">
        <div class="curmbsLink">
            <router-link to="/">首页</router-link>
            <span> > </span>
            <router-link to="/news/industry-news">行业新闻</router-link>
            <span> > </span>
            <span>新闻详情</span>
        </div>
        <div class="newDetailImage">
            <img src="../assets/images/write.png" alt="">
        </div>
        <div class="newDetailTitle">
            <div class="mouth"><span>26</span><i>七月</i></div>
            <div class="textTitle">
                <span>上半年跨境电商进口货值；无锡跨境电商综试区；社交电商；中国阿联酋海关AEO互认；俄罗斯网付网站；eBay</span>
                <p>据海关总署税收征管局（上海）统计，今年上半年，全国跨境电商零售进口商品清单达2.2亿份，货值456.5亿元。</p>
                <div>
                    <a href="javascript:;">
                        <img src="../assets/images/share.png" alt="">
                        <span>打印</span>
                    </a>NewsThree
                    <a href="javascript:;">
                        <img src="../assets/images/share.png" alt="">
                        <span>分享</span>
                    </a>
                </div>
            </div>
        </div>
        <div class="newDescriptionDetail">
            <span>上半年跨境电商进口货值超450亿元 “剁手族”买遍全球</span>
            <p>
                据海关总署税收征管局（上海）统计，今年上半年，全国跨境电商零售进口商品清单达2.2亿份，货值456.5亿元，同比分别增长20.9%和24.3%，远远高于同期全国货物贸易进口1.4%的增幅。化妆品、奶粉、尿布、食品等日用消费品的进口量在全部跨境电商零售商品中排名前列。数据还显示，今年上半年，我国消费者共计通过跨境电商平台单次购买2000－5000元进口商品80.8万份，货值23.17亿元，手链、手表、手提包等中高档商品成为其中的“抢手货”。
            </p>

            <span>无锡出台实施意见促进开发区综保区跨境电商综试区发展</span>
            <p>
                无锡市新近出台了《关于推动开放型经济高质量发展的实施意见》。今年上半年，无锡市外贸进出口总额达到461.3亿美元，增速高于全省平均6个百分点；实际使用外资规模达20.6亿美元，其中战略性新兴产业占比77.2%，列全省第一。《意见》明确了6个方面23项任务，包括进一步扩大开放领域，大力推进“一带一路”交汇点建设，着力增创外贸竞争新优势，打造法治化、国际化、便利化营商环境等，以此来共推开放型经济的高质量发展。
            </p>

            <span>中国阿联酋海关AEO互认，双方物品可优先查验</span>
            <p>
                近日，中国海关总署署长倪岳峰与阿联酋国务部长沙耶赫正式签署《中华人民共和国海关总署和阿拉伯联合酋长国联邦海关署关于中国海关企业信用管理制度与阿联酋海关“经认证的经营者”制度互认的安排》。中阿海关实现互认后，AEC企业的货物在两国通关可享受便利化待遇，有效降低企业港口、保险、物流等贸易成本，提升国际竞争力。
            </p>

            <span>俄罗斯网付网站数增15% Yandex支付“受宠”</span>
            <p>
                7月23日消息，MARC国际研究中心对俄罗斯网上商店及电商平台如何进行网上收款进行了研究。研究结果显示，2018年，可以用来进行网上支付的网站增长了15%，总共数量达到14.3万个。85%的网站上客户可以用银行卡支付，3%的网站通过支付网关收款，20%直接用网银收款，67%用现有支付解决方案。其中最大的支付解决方案是Yandex支付 （37.6%）及Robokassa(8.7%)。
            </p>

            <span>eBay：中国销往这个国家的直邮商品将不再区分价格区间段</span>
            <p>
                eBay更新了关于SpeedPAK等直邮物流管理方案的使用政策，要求对于从中国大陆销往英国的直邮商品，将不再区分价格区间段，所有直邮交易将统一纳入政策考核范围。同时对于8月底生效的英国路向新规定，合规交易率考核标准将下调至60%。新标准将于2019年9月15日评估日正式执行。
            </p>
            <b>以上信息来源于网络</b>
        </div>
    </div>
</template>

<style lang="scss">
    .newsRight {
        padding-left: 30px;
        flex: 1;
        .curmbsLink {
            width: 100%;
            line-height: 30px;
            margin-bottom: 20px;
            a { color: rgba(50,50,50, 0.3); }
            a:hover { color: #323232; }
        }
        .newDetailImage {
            padding-top: 20px;
            margin: 40px 0;
            border-top: 1px solid #ddd;
            width: 100%;
            img { width: 100%; height: auto; display: block;}
        }
        .newDetailTitle {
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 40px;
            .mouth {
                width: 100px;
                height: 120px;
                background: rgba(18, 10, 76, .4);
                display: flex;
                flex-flow: column nowrap;
                justify-content: center;
                align-items: center;
                color: #fff;
                span {
                    display: block;
                    margin-bottom: 10px;
                    font-size: 30px;
                    font-weight: 900;
                }
                i {font-size: 16px;}
            }
            .textTitle {
                flex: 1;
                padding-left: 30px;
                display: flex;
                flex-flow: column nowrap;
                justify-content: center;
                align-items: flex-start;
                span {
                    display: block;
                    font-size:24px;
                    font-weight: bold;
                    margin-bottom: 15px;
                }
                p {
                    display: block;
                    color:rgba(50, 50, 50, .5);
                    font-size: 16px;
                    margin-bottom: 20px;
                }
                div {
                    display: flex;
                    flex-flow: row nowrap;
                    justify-content: flex-start;
                    align-items: center;
                    a {
                        display: flex;
                        flex-flow: row nowrap;
                        justify-content: center;
                        align-items: flex-start;
                        margin-right: 20px;
                        img {
                            display: block;
                            width: 16px;
                            height: 16px;
                            margin-right: 15px;
                        }
                        span { font-size: 16px; margin: 0; }
                    }
                }
            }
        }
        .newDescriptionDetail {
            font-size: 14px;
            span {
                font-size: 16px;
                display: block;
                margin-bottom:10px;
            }
            p {
                color: #555;
                line-height: 34px;
                margin-bottom: 20px;
            }
        }
    }
</style>


<script>
import store from '../vuex'
// import Child from '../components/Child.vue'
export default {
  data() {
      return {
        bannerObj: {
            imgUrl: require('../assets/images/news.png'),
            text: 'NEWS',
        }
      }
  },
  store,
}
</script>

